import React from 'react';
import { Card } from '@/components/ui/card';
import { CheckCircle2 } from 'lucide-react';

const InfoSection = () => {
  const features = [
    "Securely store and manage your coaching session records",
    "Track client progress and engagement over time",
    "Organize CPD activities and supervision sessions",
    "Access powerful coaching tools and resources",
    "Generate insights and reports for your coaching practice"
  ];

  const pricingPlans = [
    {
      name: 'Coach Vault Plan',
      price: '£9.99',
      interval: '/month',
      features: [
        'Unlimited clients',
        'Advanced session tracking',
        'Advanced reporting',
        'Priority support',
        'CPD tracking',
        'Email support'
      ]
    }
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Transform Your Coaching Practice with Coach Vault
        </h2>
        <p className="text-xl text-gray-600">
          The all-in-one platform designed for professional coaches
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mb-12">
        <Card className="p-6 shadow-lg">
          <h3 className="text-xl font-semibold mb-4 text-coaching-primary">
            Key Features
          </h3>
          <ul className="space-y-3">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-2">
                <CheckCircle2 className="h-5 w-5 text-coaching-primary flex-shrink-0 mt-1" />
                <span className="text-gray-700">{feature}</span>
              </li>
            ))}
          </ul>
        </Card>

        <Card className="p-6 shadow-lg">
          <h3 className="text-xl font-semibold mb-4 text-coaching-primary">
            Why Choose Coach Vault?
          </h3>
          <div className="space-y-4 text-gray-700">
            <p>
              Imagine an app that actually grows with you. That's what this is. For £9.99 a month, you're not just getting coaching tools – you're joining a community of coaches all moving forward together.
            </p>
            <p>
              The more of us who use it, the more powerful it becomes – unlocking new features, fresh ideas, and better ways to support your clients. Every tap, every note, every session logged helps shape something we're all building together.
            </p>
            <p className="text-lg font-bold text-coaching-primary">
              You're not just using an app. You're part of something bigger.
            </p>
          </div>
        </Card>

        <Card className="p-6 shadow-lg">
          <h3 className="text-xl font-semibold mb-4 text-coaching-primary">
            Pricing Plan
          </h3>
          <div className="space-y-4">
            {pricingPlans.map((plan, index) => (
              <div key={index} className="border-b pb-4 last:border-b-0">
                <div className="flex justify-between items-center mb-2">
                  <h4 className="font-semibold text-lg">{plan.name}</h4>
                  <span className="text-coaching-primary font-bold">
                    {plan.price}{plan.interval}
                  </span>
                </div>
                <ul className="text-sm text-gray-600 space-y-1">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center gap-2">
                      <CheckCircle2 className="h-4 w-4 text-green-500 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <p className="text-xs text-gray-500 italic mt-2">
              * All plans include a 14-day free trial
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default InfoSection;
